import { IConsultCnpjResponse, IConsultCnpj } from 'entities';

export const convertConsultCnpjResponseToConsultCnpj = (
  consultCnpjResponse: IConsultCnpjResponse,
): IConsultCnpj => {
  const newResponse: IConsultCnpj = {
    document: consultCnpjResponse.cnpj,
    companyName: consultCnpjResponse.nome_fantasia || consultCnpjResponse.razao_social,
    fantasyName: consultCnpjResponse.razao_social,
    city: consultCnpjResponse.municipio,
    uf: consultCnpjResponse.uf,
    street: consultCnpjResponse.logradouro,
    number: consultCnpjResponse.numero,
    postalCode: consultCnpjResponse.cep,
    complement: consultCnpjResponse.complemento,
  };
  return newResponse;
};
